import { ResourceInfoProvider } from '@openx/components-core/lib/Form/context/ResourceInfoContext.tsx';
import type { DealDetailsSectionProps } from '../../types.ts';
import type { DetailsTabDeal } from './DealDetailsTab.tsx';
import { CuratedDealFeesDetailsSection } from './sections/CuratedDealFeesSection/CuratedDealFeesDetailsSection.tsx';
import { DealDetailsSection } from './sections/DealDetailsSection/DealDetailsSection.tsx';
import { DealFloorAndDurationSection } from './sections/DealFloorAndDurationSection.tsx';
import { IdsDetailsSection } from './sections/IdsDetailsSection.tsx';
import { TargetingCriteriaDetailsSection } from './sections/TargetingCriteriaDetailsSection.tsx';

export const DirectDealDetailsTab = <T extends DetailsTabDeal = DetailsTabDeal>({
  deal,
  historyMode,
}: DealDetailsSectionProps<T>) => {
  return (
    <ResourceInfoProvider name="deal">
      <IdsDetailsSection<T> deal={deal} historyMode={historyMode} />

      <DealDetailsSection<T> deal={deal} historyMode={historyMode} />

      <DealFloorAndDurationSection<T> deal={deal} historyMode={historyMode} />

      <CuratedDealFeesDetailsSection<T> deal={deal} historyMode={historyMode} />

      <TargetingCriteriaDetailsSection<T> deal={deal} historyMode={historyMode} />
    </ResourceInfoProvider>
  );
};
